import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import showInfo from '@/pages/components/showInfo'
import facilityCloud from '@/pages/components/facilityCloud'
import about from '@/pages/components/about'
import map from '@/pages/components/map'
import EN from '@/pages/components/EN'
import xqapp from '@/pages/components/xqapp'
import solution from '@/pages/components/solution'
import engine from '@/pages/components/engine'
import connect from '@/pages/components/connect'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  },{
    path: '/showInfo',
    name: 'showInfo',
    component: showInfo
  },{
    path: '/facilityCloud',
    name: 'facilityCloud',
    component: facilityCloud
  },{
    path: '/about',
    name: 'about',
    component: about
  },{
    path: '/map',
    name: 'map',
    component: map
  },{
    path: '/EN',
    name: 'EN',
    component: EN
  },{
    path: '/xqapp',
    name: 'xqapp',
    component: xqapp
  },{
    path: '/solution',
    name: 'solution',
    component: solution
  },{
    path: '/engine',
    name: 'engine',
    component: engine
  },{
    path: '/connect',
    name: 'connect',
    conponent: connect
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js